/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface UserOfGroup {
  email: string;
  id: string;
  firstName: string;
  lastName: string;
  /**
   * SMA: null when the member has no picture. Widened by hand, like the
   * other fields here: `generate:sdk` needs a running API.
   */
  avatarUrl: string | null;
  isNameAnonymous?: boolean;
}
